<template>
	<div class="not-found">
		<a-result status="warning" title="页面不存在" sub-title="您访问的页面不存在或已被移除，请检查地址是否正确。">
			<template #icon>
				<div class="not-found__icon">
					<span class="not-found__code">404</span>
					<a-icon type="compass" class="not-found__compass" />
				</div>
			</template>
			<template #extra>
				<router-link class="ant-btn ant-btn-primary" to="/">返回首页</router-link>
			</template>
		</a-result>
	</div>
</template>

<script>
export default {
	name: 'NotFound',
}
</script>

<style lang="scss" scoped>
.not-found {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 60vh;
	padding: 40px 16px;
}

.not-found__icon {
	position: relative;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 140px;
	height: 140px;
	margin: 0 auto;
	border-radius: 50%;
	background: rgba(24, 144, 255, 0.08);
}

.not-found__code {
	font-size: 44px;
	font-weight: 700;
	letter-spacing: 2px;
	color: #1890ff;
	line-height: 1;
}

.not-found__compass {
	position: absolute;
	top: -10px;
	right: -10px;
	font-size: 36px;
	color: #1890ff;
	background: #fff;
	border-radius: 50%;
	padding: 4px;
	box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}
</style>
